import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack, Textarea } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';

const NotesField = ({ darkMode, requiredScope, values, setFieldValue }) => {
    const [isHovered, setIsHovered] = useState(false);

    // Only show for scope 80
    if (requiredScope !== 80) {
        return null;
    }

    return (
        <FormControl
            sx={{ margin: '0 !important', marginBottom: '20px !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Notes
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Add any relevant notes regarding this number block.
                    </Text>
                </Box>
                <Box flex="1" maxWidth="100%">
                    <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '15px' }}>
                        <VStack width="100%" alignItems="normal" spacing={0}>
                            <Textarea
                                name="internalNotes"
                                id="internalNotes"
                                placeholder="Relevant notes regarding this number block"
                                value={values.internalNotes || ''}
                                onChange={(e) => setFieldValue('internalNotes', e.target.value)}
                                resize="none"
                                rows={3}
                                maxHeight="120px"
                                overflow="auto"
                            />
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Add internal notes about this number block for reference"
                        ariaLabel="notes-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default NotesField;